import type {
  QualFinalRecap,
  QualMancheRecap,
  SimulateSessionResponse,
} from '@multirx/shared/types/championship.js';

export const ARCHIVE_AUTOPLAY_SESSION_KEY = 'multirx-archive-autoplay';
export const ARCHIVE_RETURN_TO_SESSION_KEY = 'multirx-archive-return-to';
export const ARCHIVE_PENDING_QUAL_RECAPS_KEY = 'multirx-archive-pending-qual-recaps';

export type PendingQualRecaps = {
  qualMancheRecap?: QualMancheRecap | null;
  qualFinalRecap?: QualFinalRecap | null;
};

/** Prépare la navigation simulate → replay (autoplay + retour saison). */
export function prepareArchiveReplayFromSimulate(
  response: SimulateSessionResponse,
  returnHash = 'saisons',
  storage: Pick<Storage, 'setItem' | 'removeItem'> = sessionStorage
): number | null {
  const id = response.completedSession.raceHistoryId;
  if (id == null || !Number.isFinite(id) || id <= 0) return null;

  storage.setItem(ARCHIVE_AUTOPLAY_SESSION_KEY, '1');
  storage.setItem(ARCHIVE_RETURN_TO_SESSION_KEY, returnHash.replace(/^#/, ''));

  const pending: PendingQualRecaps = {
    qualMancheRecap: response.qualMancheRecap ?? null,
    qualFinalRecap: response.qualFinalRecap ?? null,
  };
  if (pending.qualMancheRecap || pending.qualFinalRecap) {
    storage.setItem(ARCHIVE_PENDING_QUAL_RECAPS_KEY, JSON.stringify(pending));
  } else {
    storage.removeItem(ARCHIVE_PENDING_QUAL_RECAPS_KEY);
  }
  return id;
}

export function consumeArchiveAutoplayFlag(
  storage: Pick<Storage, 'getItem' | 'removeItem'> = sessionStorage
): boolean {
  const on = storage.getItem(ARCHIVE_AUTOPLAY_SESSION_KEY) === '1';
  storage.removeItem(ARCHIVE_AUTOPLAY_SESSION_KEY);
  return on;
}

export function peekArchiveReturnTo(
  storage: Pick<Storage, 'getItem'> = sessionStorage
): string | null {
  const raw = storage.getItem(ARCHIVE_RETURN_TO_SESSION_KEY);
  return raw && raw.trim() ? raw.replace(/^#/, '') : null;
}

export function clearArchiveReturnTo(storage: Pick<Storage, 'removeItem'> = sessionStorage): void {
  storage.removeItem(ARCHIVE_RETURN_TO_SESSION_KEY);
}

export function consumePendingQualRecaps(
  storage: Pick<Storage, 'getItem' | 'removeItem'> = sessionStorage
): PendingQualRecaps | null {
  const raw = storage.getItem(ARCHIVE_PENDING_QUAL_RECAPS_KEY);
  storage.removeItem(ARCHIVE_PENDING_QUAL_RECAPS_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PendingQualRecaps;
  } catch {
    return null;
  }
}

export function archivesDetailHashFromId(id: number): string {
  return `archives/${id}`;
}
